module.exports = __webpack_public_path__ + "static/media/avatar-jlc.d38291bd.jpg";